/**
 * Created by yoavp on 8/25/2015.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/agent-groups/agentGroupsMembersGridRowView.tmpl");

    var Checkbox = require("ui/checkbox/Checkbox");
    var Loader = require("ui/loader/Loader");
    var PlusCompositeView = require("ui/plus-composite-view/PlusCompositeView");

    var EMPTY_DATA = "-";

    var AgentGroupsMembersGridRowView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupsMembersGridRowView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "agent-group-row",
            template: template,
            loaders: [],
            ui: {
                name: ".name .content",
                skills: ".skills",
                maxChatsCell: ".max-chats",
                maxChatsContent: ".max-chats .content",
                maxConversationsCell: ".max-conversations",
                maxConversationsContent: ".max-conversations .content",
                skillsContent: ".skills .content",
                assignedDate: ".assigned-date"
            },
            uiComponents: {

            },
            events: {
                "click @ui.name": "_onRowClick",
                "click @ui.skills": "_onRowClick",
                "click @ui.maxChatsCell": "_onRowClick",
                "click @ui.maxConversationsCell": "_onRowClick",
                "click @ui.assignedDate": "_onRowClick"
            },

            initialize: function() {
                this.loaders = [];
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_EDIT);
                this._bindEvents();
            },

            onRender: function() {
                this._updateName();
                this._updateMaxNumberOfChats();
                this._updateMaxNumberOfConversations();
                this._updateSkills();
                this._updateMemberAssignmentDate();
                this._setTooltipOnName();
                _.defer(_.bind(this._handleEllipsis, this));
            },

            _bindEvents: function (checked) {

            },

            _updateName: function() {
                var name = this.model.getDisplayName();
                this.ui.name.text(name);
            },

            _updateMaxNumberOfChats: function() {
                var maxNumberOfChats = this.model.getMaxNumberOfChats();
                if(maxNumberOfChats === this.model.MAX_CHATS_CONST.UNLIMITED) {
                    maxNumberOfChats = LE.translator.translate("LEUserManagement.userEdit.maxChats.unlimited.label");
                }
                this.ui.maxChatsContent.text(maxNumberOfChats);
            },

            _updateMaxNumberOfConversations: function(){
                var hasAsyncMessagingFeature = LE.sessionManager.hasAsyncMessagingFeature();
                if(hasAsyncMessagingFeature){
                    var maxConversations = this.model.getMaxConversations();
                    if(_.isNull(maxConversations) || _.isUndefined(maxConversations)) {
                        var settingsCollection = LEUserManagement.getDataManager().getSiteSettingsUserList();
                        maxConversations = settingsCollection.get(settingsCollection.SETTINGS_ENUM.SETTING_ID.MAX_CONVERSATIONS).getValue();
                    }
                    this.ui.maxConversationsContent.text(maxConversations);
                }
                else {
                    this.ui.maxConversationsCell.toggleClass("hide", true);
                }
            },

            _updateMemberAssignmentDate: function() {
                var memberAssignmentDate = this.model.getMemberAssignmentDate();
                var formatedDate = this._changeDateFormat(memberAssignmentDate);
                this.ui.assignedDate.text(formatedDate);
            },

            _changeDateFormat: function(date) {
                date = date.replace(/-/g,'/');
                var newDate = new Date(date);
                var month = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.",
                    "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."][newDate.getMonth()];
                var year = newDate.getFullYear();
                var day = newDate.getDate();
                var str = day + ' ' + month + ' ' + year;
                return str;
            },

            _getSkillsNamesArray: function() {
                var skills = this.model.getSkills();
                var dataManagerObject = LEUserManagement.getDataManager();
                skills = dataManagerObject.getArrayNamesByIds(dataManagerObject.getEntities().SKILL, skills);
                this.model.skills = skills;
                return skills;
            },


            _updateSkills: function() {
                var skills = this._getSkillsNamesArray();

                if (skills === this.model.NO_DATA) {
                }
                else {
                    if (skills.length > 0 || true) {
                        this.uiComponents.host$.createAndRender("skills", {
                            type: PlusCompositeView,
                            options: {
                                container: "view.ui.skillsContent",
                                collection: "view._getSkillsCollection",
                                textModelAttr: "tooltip",
                                visibleItemsCount: 1,
                                itemView: PlusCompositeView.DefaultPlusComponentItemView,
                                permutation: PlusCompositeView.PERMUTATIONS.DEFAULT
                            }
                        });
                    }
                    else {
                        this.ui.skills.text(EMPTY_DATA);
                    }
                }
            },

            _getSkillsCollection: function() {
                var skills = this.model.skills;
                var skillsWIthToolTip = this._addToolTip(skills);
                var sortedSkills = this._sortSkillsByName(skillsWIthToolTip);
                return new PlusCompositeView.DefaultPlusComponentCollection(sortedSkills);
            },

            _sortSkillsByName: function(skills) {
                skills.sort(function(a, b){
                    return a.name.toLowerCase() > b.name.toLowerCase() ? 1:-1;
                });
                return skills;
            },


            _onRowClick: function() {
                //this.channel.trigger("row:click", this.model);
            },

            _addToolTip: function(skills) {
                for (var ii = 0; ii < skills.length; ii++) {
                    if (skills[ii].name) {
                        skills[ii].tooltip = skills[ii].name;
                    }
                }
                return skills;
            },

            _handleEllipsis: function() {
                setTimeout(_.defer(_.bind(this._setTooltipOnName, this)), 1000);
            },

            _setTooltipOnName: function() {
                var tooltip = this.model.getDisplayName() + " <" + this.model.getLoginName() + ">";
                if(!this.model.getEnabled()) {
                    tooltip += " - " + LE.translator.translate("LEUserManagement.agentGroupEdit.member.disabled");
                }
                this.ui.name.attr("title", tooltip);
                this.ui.name.attr("tooltip-text", tooltip);
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupsMembersGridRowView;
});

